module.exports = __webpack_public_path__ + "media/images/bin_wt-c9150d1d319763be559727927b0ecfb8.png";